import React, { Component } from 'react';
import LightMobileCall from '@kugou/light-mobilecall';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import 'swiper/modules/navigation/navigation.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'swiper/modules/scrollbar/scrollbar.min.css';
import 'swiper/swiper.min.css';
import './Index.scss'
import 'intersection-observer'
const data = require('./Index.data');

function pxtovw(value) {
  let vw = (100 * value) / 750;
  vw = vw.toFixed(3);
  return vw + 'vw';
}

function checkIntoViewCb(el, succCb, failCb) {
  let intersectionObserverOptions = {
    threshold: 0.9,
    rootMargin: '0px',
  }
  let intersectionObserver = new IntersectionObserver(([change]) => {
    if (change.isIntersecting) {
      succCb && succCb()
    } else {
      failCb && failCb()
    }
  }, intersectionObserverOptions);
  el && intersectionObserver.observe(el)
}

class Index extends Component {
  constructor(props) {
    super(props);
    this.isExpose = false
    this.swiperRef = React.createRef()
  }
  componentDidMount() {
    //修改分页器颜色
    this.initConfigInfo(data)
    checkIntoViewCb(this.swiperRef.current, () => {
      this.isExpose = true
    })
  }
  initConfigInfo(props) {
    document.getElementsByTagName('body')[0].style.setProperty('--test', props.pagination.color)
    document.getElementsByTagName('body')[0].style.setProperty('--bullet', pxtovw(props.pagination.size))
    if (props.style === '3d') { document.getElementsByTagName('body')[0].style.setProperty('--style', 0.80) }
    else if (props.style === 'common') { document.getElementsByTagName('body')[0].style.setProperty('--style', 1) }
  }
  componentWillReceiveProps() {
    this.initConfigInfo(data)
  }
  handleSwiper(index) {
    if (data.list[index].jumpUrl) {
      if(LightMobileCall.isInClient()){
        LightMobileCall.mobileCall(123, {
          url: data.list[index].jumpUrl
        })
      }else{
        window.location.href = data.list[index].jumpUrl
      }
    }
  }

  render() {
    const { style, autoplay, navigation, pagination, androidNoSwiping, iosNoSwiping } = data
    const noSwiping = (!LightMobileCall.isIOS && androidNoSwiping || LightMobileCall.isIOS && iosNoSwiping) ? true : false
    return (
      <>
        <Swiper
          className='swiper'
          ref={this.swiperRef}
          modules={[Navigation, Pagination, A11y, Autoplay]}
          spaceBetween={0}
          slidesPerView={style === 'common' ? 1 : 'auto'}
          centeredSlides={true}
          loop
          noSwiping={noSwiping}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          pagination={pagination.ifShow ? { //小圆点配置
            clickable: true,
            el: '.swiper-pagination',
            bulletActiveClass: 'swiper-pagination-bullet-active',
            bulletClass: 'swiper-pagination-bullet',
          } : false}
          autoplay={ //自动播放配置
            autoplay.ifAutoplay ?
              {
                delay: autoplay.delay * 1000,
                disableOnInteraction: false
              } :
              false}
          // onSlideChange={() => console.log('slide change')}
          // onSwiper={(swiper) => console.log(swiper)}
        >
          {data.list.map((item, index) =>
            <SwiperSlide className={`swiperSlide ${noSwiping && 'swiper-no-swiping'}`} key={index} onClick={this.handleSwiper.bind(this, index)}>
              <img src={item.img} alt='' style={{ width: item.width ? pxtovw(item.width) : undefined, height: item.height ? pxtovw(item.height) : undefined}}></img>
              <div className='swiperDesc'>{item.desc}</div>
            </SwiperSlide>)
          }
          {navigation.ifShow ? <div><div className={`swiper-button-prev ${noSwiping && 'swiper-no-swiping'}`} style={{ color: navigation.color, '--swiper-navigation-size': pxtovw(navigation.size) }}></div>
            <div className='swiper-button-next' style={{ color: navigation.color, '--swiper-navigation-size': pxtovw(navigation.size) }}></div></div> : null}

          <div className={`swiper-pagination ${noSwiping && 'swiper-no-swiping'}`} style={{ textAlign: pagination.position ? pagination.position : 'center' }}>
            {/* <div className='swiper-pagination-bullet-active' style={{ backgroundColor: 'blue' }}></div>
            <div className='swiper-pagination-bullet' style={{ backgroundColor: 'black' }}></div> */}
          </div>
        </Swiper>
      </>
    );
  }
}

export default Index;
